import { defineComponent as _defineComponent } from 'vue'
import AzButton from '~/components/_next/atoms/AzButton.vue';

export type Tab = {
  sys: {
    id: string;
  };
  title: string;
  listOfProducts?: string[];
};


export default /*#__PURE__*/_defineComponent({
  __name: 'TabsFilter',
  props: {
    tabs: null,
    currentTabIndex: { default: 1 }
  },
  emits: ['tabSelected'],
  setup(__props: any, { emit }) {

const props = __props as { tabs?: Tab[], currentTabIndex: number };





return { __sfc: true,props, emit, AzButton }
}

})